function pointMoreThanTwo(num: number): boolean {
    let numStr = num.toString()
    return numStr.includes('.') && numStr.slice(numStr.indexOf('.') + 1).length > 2
}

export { pointMoreThanTwo }